/**
 * ROC 7
 * Copyright 2017 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */

define('modules/Upcharges/Impl/RushOrderUpcharge',[
    'jquery',
    'lodash',
    'global/all',
    'modules/Cart/CartManager',
    'modules/Upcharges/UpchargeService',
    'modules/Upcharges/UpchargeRegistrationService'
], function ($, _, Roc, CartManager, UpchargeService, UpchargeRegistrationService) {
    'use strict';


    var checkboxSelector = 'input[data-roc-action="addRushOrderUpcharge"]';

    var upchargeCode = 'RUSHORDER';


    function initForCheckout(checkoutViewModel) {
        
        var isRushOrderEnabled = false;
        var rushOrderUpchargeFee = 5;
        var upchargesSettings = checkoutViewModel.upchargesConfiguration;
        var rushOrderConfiguration = _.find(upchargesSettings, function (upchargeSettings) {
            return upchargeSettings.upchargeCode == upchargeCode;
        });

        if (rushOrderConfiguration && rushOrderConfiguration.configuration["isRushOrderEnabled"]) {
            isRushOrderEnabled = rushOrderConfiguration.configuration["isRushOrderEnabled"];
        }
        
        if (rushOrderConfiguration && rushOrderConfiguration.configuration["rushOrderUpchargeFee"]) {
            rushOrderUpchargeFee = rushOrderConfiguration.configuration["rushOrderUpchargeFee"];
        }

        _.each(checkoutViewModel.order.recipients, function (recip) {

            recip.isRushOrderEnabled = isRushOrderEnabled;
            recip.rushOrderFee = rushOrderUpchargeFee;
            recip.isRushOrder = _.some(recip.upcharges, function (upcharge) {
                return upcharge.code === upchargeCode;
            });
        });
    }

    function bindEvents() {
        $(document)
            .off('change', checkboxSelector)
            .on('change', checkboxSelector, onRushOrderChanged);
    }


    function onRushOrderChanged() {

        var isRushOrder = $(this).is(':checked');

        var $recipientContainer = getRecipientContainerByElement(this);
        var recipientId = $recipientContainer.attr('data-recipient-id');

        var rushOrderPanelSelector = '#rushOrderPanel-' + recipientId;

        Roc.UI.block(rushOrderPanelSelector);

        var promise;

        if (isRushOrder) {
            promise = UpchargeService.addRecipientUpcharge(recipientId, upchargeCode);
        } else {
            promise = UpchargeService.removeRecipientUpcharge(recipientId, upchargeCode);
        }

        promise.then(function () {
            Roc.UI.block('#slideCartRail');

            // now that we've added the rush order upcharge, recalculate the current cart to update the cart slide rail
            return CartManager.getCurrentCart(true)
                .always(function () {
                    Roc.UI.unblock('#slideCartRail');
                });

        }).always(function () {
            Roc.UI.unblock(rushOrderPanelSelector);
        });

    }

    function getRecipientContainerByElement(target) {
        return $(target).closest('div.panel-secondary[data-recipient-id]');
    }


    var RushOrderUpcharge = {
        initForCheckout: initForCheckout,
        bindEvents: bindEvents
    };

    Roc.Logger.debug('RushOrderUpcharge.js Loaded:', RushOrderUpcharge);

    // register upcharge
    UpchargeRegistrationService.register(upchargeCode, RushOrderUpcharge);

    return RushOrderUpcharge;
});

